<template>
    <!-- BI内容 -->
    <div class="BI-area" v-loading="loading">
        <div class="search-content">
            <SearchTools :searchField="searchField" :key="timer" @searchData="searchData">

            </SearchTools>
        </div>
        <!-- 柱状图 -->
        <div class="BI-area-one"  v-if="chartType==1">
            <ve-histogram :ref="'echartTwo'+index"
                :data="chartData"
                :settings="chartSettings"
                :extend="chartExtend"
                :width="dashBoardWidth"
                :height="dashBoardHeight"
                @finished="finished"
                :toolbox="toolbox"
                >
            </ve-histogram>
        </div>
        <!-- 饼状图 -->
        <div class="BI-area-one" v-if="chartType==2">
            <ve-pie ref="echartOne" :data="chartData" :settings="chartSettings" :width="dashBoardWidth" :height="dashBoardHeight" :toolbox="toolbox"></ve-pie>
        </div>
        <!-- 条形图 -->
        <div class="BI-area-one"  v-if="chartType==3">
            <ve-bar ref="echartThree" :data="chartData" :settings="chartSettings"  :extend="chartExtend" :width="dashBoardWidth" :height="dashBoardHeight" :toolbox="toolbox"></ve-bar>
        </div>
        <!-- 折线图 -->
        <div class="BI-area-one"  v-if="chartType==4">
            <ve-line ref="echartFour" :data="chartData" :settings="chartSettings"  :extend="chartExtend" :width="dashBoardWidth" :height="dashBoardHeight" :toolbox="toolbox"></ve-line>
        </div>
        <!-- 环形图 -->
        <div class="BI-area-one"  v-if="chartType==5">
            <ve-ring ref="echartFive" :data="chartData" :settings="chartSettings"  :width="dashBoardWidth" :height="dashBoardHeight" :toolbox="toolbox"></ve-ring>
        </div>
        <el-row type="flex" justify="end" v-if="showPage&&page.totalPageNum > page.pageSize" class="bi-page-content">
            <el-pagination
                background
                layout="sizes,total, prev, pager, next"
                :total="page.totalPageNum"
                :current-page="page.currentPage"
                @size-change="handleSizeChange"
                :page-size="page.pageSize"
                @current-change="queryTableData"
                :page-sizes="[10, 30, 50]"
            />
        </el-row>
            <el-dialog
            append-to-body
            :visible.sync="isShowOrderOptions"
            top="4vh" 
            >
            <el-cascader  ref="sortCascader"  :options="orderOptions" clearable></el-cascader>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isShowOrderOptions = false">取 消</el-button>
                <el-button type="primary" @click="sortSearch">排序查询</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import { cloneDeep } from 'lodash';
    import SearchTools from './SearchTools';
    import {getFormDashBoardData} from '@/data-model';
    export default{
        name: 'DashBoard',
        components: {
            SearchTools: SearchTools
        },
        props: {
            dashBoardWidth: {
                type: String
            },
            dashBoardHeight: {
                type: String
            },
            searchCondition: {
                type: Array
            },
            chartType: {
                type: Number
            },
            index: {
                type: String,
                default: '0'
            },
            dataId: {
                type: String,
                default: ''
            },
            showSearchList: {
                type: Array
            },
            cacheDataId: {
                type: String,
                default: ''
            }
        },
        data () {
            var magicType = [];
            var seriesType = 'bar';
            if (this.chartType === 1 || this.chartType === 3 || this.chartType === 4) {
                magicType = ['line', 'bar'];
                if (this.chartType === 4) {
                    seriesType = 'line';
                } else {
                    seriesType = 'bar';
                }
            } else if (this.chartType === 2 || this.chartType === 5) {
                magicType = [];
                seriesType = 'pie';
            }
            this.chartExtend = {
                series: {
                    // barWidth: 30
                    type: seriesType, // 添加该属性
                    label: { show: this.showBiWay === 1, position: 'top' }
                },
                xAxis: {
                    axisLabel: {
                        // margin: 15,
                        interval: 0,
                        // rotate: 30,
                        formatter: function (value) {
                            if (value.length > 10) {
                                return value.substring(0, 10).concat('...');
                            } else {
                                return value;
                            }
                        }
                    },
                    triggerEvent: true
                }
            };
            this.toolbox = {
                orient: 'vertical', // 垂直显示
                y: 'center', // 延Y轴居中
                x: 'right', // 居右显示
                feature: {
                    myTool2: {
                        show: true,
                        title: '排序',
                        icon: 'M156.392727 656.523636a43.52 43.52 0 0 1 61.207273 7.214546l113.105455 144.058182V90.298182a43.752727 43.752727 0 1 1 87.272727 0v843.403636a43.752727 43.752727 0 0 1-29.323637 41.425455 42.123636 42.123636 0 0 1-14.196363 2.327272 43.287273 43.287273 0 0 1-34.210909-16.756363L148.945455 717.730909a43.52 43.52 0 0 1 7.447272-61.207273zM634.414545 48.872727a43.752727 43.752727 0 0 1 48.64 14.429091l191.069091 242.967273a43.752727 43.752727 0 1 1-69.818181 53.992727l-111.941819-144.058182v717.498182a43.752727 43.752727 0 1 1-87.272727 0V90.298182a44.218182 44.218182 0 0 1 29.323636-41.425455z',
                        onclick: () => {
                            this.showOrderOptions();
                        }
                    },
                    magicType: {type: magicType},
                    saveAsImage: {show: true},
                    dataView: { // 数据视图
                        show: true,
                        optionToContent: function (opt) {
                            let axisData = opt.xAxis[0].data; // 坐标数据
                            let series = opt.series; // 折线图数据
                            let tdHeads = '<td  style="padding: 0 10px"></td>'; // 表头
                            let tdBodys = ''; // 数据
                            series.forEach(function (item) {
                                // 组装表头
                                tdHeads += `<td style="padding: 0 10px">${item.name}</td>`;
                            });
                            let table = `<table border="1" style="margin-left:20px;border-collapse:collapse;font-size:14px;text-align:center"><tbody><tr>${tdHeads} </tr>`;
                            for (let i = 0, l = axisData.length; i < l; i++) {
                                for (let j = 0; j < series.length; j++) {
                                    // 组装表数据
                                    tdBodys += `<td>${series[j].data[i] === undefined || series[j].data[i] === null || series[j].data[i] === 'null' ? 0 : series[j].data[i]}</td>`;
                                }
                                table += `<tr><td style="padding: 0 10px">${axisData[i] === undefined || axisData[i] === null || axisData[i] === 'null' ? 0 : axisData[i]}</td>${tdBodys}</tr>`;
                                tdBodys = '';
                            }
                            table += '</tbody></table>';
                            return table;
                        }
                    }
                }
                // orient: 'vertical'
            };

            return {
                time: new Date().getTime(),
                dataZoom: [
                    {id: 'dataZoomX', type: 'slider', show: false, xAxisIndex: 0, left: '90%', start: 10, end: 90},
                    {id: 'dataZoomY', disabled: true, type: 'inside', show: true, yAxisIndex: [0], start: 10, end: 90},
                    {start: 0, end: 100, height: 20}
                ],
                showPage: false,
                page: {
                    currentPage: 1, // 当前页码
                    pageSize: 10, // 每页条数
                    totalPageNum: 0 // 总页数
                },
                allData: [],
                loading: true,
                chartData: {},
                chartSettings: {},
                showBiWay: 0,
                searchField: [],
                timer: '',
                isShowOrderOptions: false
            };
        },
        created () {
            if (this.dataId) { // 获取BI的配置
                this.$nextTick(() => {
                    this.getDashBoardData();
                });
                if (this.showSearchList && this.showSearchList.length > 0) {
                    this.searchField = cloneDeep(this.showSearchList);
                }
            } else {
                this.loading = false;
            }
        },
        methods: {
            async getDashBoardData (searchCondition) {
                this.loading = true;
                let searchParam = [];
                if (searchCondition) {
                    searchParam = searchCondition;
                } else {
                    searchParam = this.searchCondition;
                }
                let iSearchCondition = {searchCondition: searchParam, formId: this.dataId, cacheDataId: this.cacheDataId};
                let obj = await getFormDashBoardData(iSearchCondition);
                if (obj.showBiWay === 1) {
                    this.chartExtend.series.label.show = true;
                }
                if (obj) {
                    this.chartSettings = obj.chartSettings;
                    this.chartData = obj.chartData;
                    this.showBiWay = obj.showBiWay;
                    if (this.chartData && this.chartData.rows.length > 1) {
                        this.dataZoom = [];
                        this.showPage = true;
                        this.allData = this.chartData.rows;
                        this.page.totalPageNum = this.chartData.rows.length;
                        this.dealData();
                    }
                }
                this.loading = false;
                setTimeout(() => { // 调用子组件的方法
                    this.resizeChart();
                }, 100);
            },
            renderModel (obj) {
                let seriesType = '';
                if (obj.chartType === 1 || obj.chartType === 3 || obj.chartType === 4) {
                    if (obj.chartType === 4) {
                        seriesType = 'line';
                    } else {
                        seriesType = 'bar';
                    }
                } else if (obj.chartType === 2 || obj.chartType === 5) {
                    seriesType = 'pie';
                }
                this.chartExtend.series.type = seriesType;
                this.chartSettings = obj.chartSettings;
                this.chartData = obj.chartData;
                if (this.chartData && this.chartData.rows.length > 1) {
                    this.dataZoom = [];
                    this.showPage = true;
                    this.allData = this.chartData.rows;
                    this.page.totalPageNum = this.chartData.rows.length;
                    this.dealData();
                }
            },
            resizeChart () {
                if (this.$refs['echartTwo' + this.index]) {
                    this.$refs['echartTwo' + this.index].resize();
                }
                if (this.$refs['echartFour' + this.index]) {
                    this.$refs['echartFour' + this.index].resize();
                }
            },
            handleSizeChange (val) {
                this.page.pageSize = val;
                this.dealData();
            },
            dealData () {
                // 分页操作，每次取当前页*每页显示的条数再加每页显示的条数
                let cpage = (this.page.currentPage - 1) * this.page.pageSize;
                let count = this.page.pageSize + cpage;
                this.chartData.rows = this.allData.slice(cpage, count);
                if (this.chartData.rows.length < 1) {
                    this.$message({
                        message: '没有查询到数据',
                        type: 'warning'
                    });
                }
            },
            queryTableData (currentPage) {
                this.page.currentPage = currentPage;
                this.dealData();
            },
            finished () {

            },
            renderSearchField (o) {
                this.searchField = cloneDeep(o);
                this.timer = new Date().getTime();
            },
            searchData (arr) {
                this.getDashBoardData(arr);
            },
            showOrderOptions () {
                this.orderOptions = [];
                this.chartData.columns.forEach(item => {
                    let optionObj = {};
                    optionObj.value = item;
                    optionObj.label = item;
                    optionObj.children = [{value: 'asc', label: '升序'}, {value: 'desc', label: '降序'}];
                    this.orderOptions.push(optionObj);
                });
                this.isShowOrderOptions = true;
            },
            sortSearch () {
                let checkedNodes = this.$refs.sortCascader.getCheckedNodes();
                if (checkedNodes && checkedNodes[0].path) {
                    this.sortData({sort: checkedNodes[0].path[1]}, checkedNodes[0].path[0]);
                    this.isShowOrderOptions = false;
                }
            },
            sortData (o, column) {
                this.allData.forEach(item => {
                    item.sort = o.sort;
                });
                this.allData.forEach(item => {
                    this.allData.sort(this.sortMethod(column, item.sort));
                });
                this.dealData();
                this.$forceUpdate();
            },
            sortMethod (prop, sortType) {
                return function (obj1, obj2) {
                    var val1 = !isNaN(Number(obj1[prop])) ? Number(obj1[prop]) : 0;
                    var val2 = !isNaN(Number(obj2[prop])) ? Number(obj2[prop]) : 0;
                    if (val1 < val2) {
                        return sortType === 'asc' ? -1 : 1;
                    } else if (val1 > val2) {
                        return sortType === 'asc' ? 1 : -1;
                    } else {
                        return 0;
                    }
                };
            }
        }
    };
</script>

<style lang="less">
    .ve-histogram{
        margin-right: 20px;
    }
    .bi-page-content{
        position: relative;
        top: -46px;
    }
</style>



// WEBPACK FOOTER //
// src/components/DataWarehousing/DashBoard.vue